<div class="custom-date-wrapper" style="border-radius: 0px !important">
  <!-- Header with hamburger -->
  <div class="filter-header">
    <span>
      <img
        class="inbox-search-option"
        src="assets/qwyn/icons/hamburger_menu.svg"
        alt="hamburger_icon"
      />
    </span>
  </div>

  <hr class="divider" />

  <!-- ========== FIRST CONDITION ========== -->
  <div class="filter-condition">
    <!-- FIRST dropdown -->
    <div class="select-wrapper">
      <button
        type="button"
        class="dropdown-trigger"
        (click)="toggleDropdown(0)"
        [class.dropdown-open]="dropdownOpenIndex === 0"
      >
        <span>{{ getOptionLabel(filterConditions[0].type) }}</span>
        <img
          src="assets/qwyn/icons/filter_dropdown.svg"
          class="select-icon"
          alt="dropdown_icon"
        />
      </button>

      <div *ngIf="dropdownOpenIndex === 0" class="dropdown-panel">
        <button
          *ngFor="let option of filterOptions"
          type="button"
          class="dropdown-option"
          [attr.aria-selected]="option.value === filterConditions[0].type"
          [class.selected]="option.value === filterConditions[0].type"
          (click)="selectOption(0, option.value)"
        >
          {{ option.label }}
        </button>
      </div>
    </div>

    <!-- FIRST date input -->
    <div class="input-wrapper" *ngIf="!isBlankType(filterConditions[0].type)">
      <div class="date-input-wrapper">
        <input
          type="date"
          [(ngModel)]="filterConditions[0].valueString"
          (ngModelChange)="onFilterChanged()"
        />
        <span class="calendar-icon ag-icon ag-icon-calendar"></span>
      </div>
    </div>
  </div>

  <!-- AND / OR -->
  <div *ngIf="isFirstConditionSet()" class="junction-options">
    <label class="radio-label">
      <input
        type="radio"
        [(ngModel)]="junction"
        value="AND"
        (change)="onFilterChanged()"
      />
      AND
    </label>

    <label class="radio-label">
      <input
        type="radio"
        [(ngModel)]="junction"
        value="OR"
        (change)="onFilterChanged()"
      />
      OR
    </label>
  </div>

  <!-- ========== SECOND CONDITION ========== -->
  <div *ngIf="isFirstConditionSet()" class="filter-condition">
    <!-- SECOND dropdown -->
    <div class="select-wrapper">
      <button
        type="button"
        class="dropdown-trigger"
        (click)="toggleDropdown(1)"
        [class.dropdown-open]="dropdownOpenIndex === 1"
      >
        <span>{{ getOptionLabel(filterConditions[1].type) }}</span>
        <img
          src="assets/qwyn/icons/filter_dropdown.svg"
          class="select-icon"
          alt="dropdown_icon"
        />
      </button>

      <div *ngIf="dropdownOpenIndex === 1" class="dropdown-panel">
        <button
          *ngFor="let option of filterOptions"
          type="button"
          class="dropdown-option"
          [attr.aria-selected]="option.value === filterConditions[1].type"
          [class.selected]="option.value === filterConditions[1].type"
          (click)="selectOption(1, option.value)"
        >
          {{ option.label }}
        </button>
      </div>
    </div>

    <!-- SECOND date input -->
    <div class="input-wrapper" *ngIf="!isBlankType(filterConditions[1].type)">
      <div class="date-input-wrapper">
        <input
          type="date"
          [(ngModel)]="filterConditions[1].valueString"
          (ngModelChange)="onFilterChanged()"
        />
        <span class="calendar-icon ag-icon ag-icon-calendar"></span>
      </div>
    </div>
  </div>

  <!-- RESET -->
  <ng-container *ngIf="isFirstConditionSet()">
    <hr class="divider" />
    <div class="button-wrapper">
      <button class="reset-button" (click)="resetFilter()">Reset</button>
    </div>
  </ng-container>
</div>
